import React from "react";
import Images from "../../images";

const ProfileItem = ({ onClick, title, time, description, image }) => {
  return (
    <div
      className="p-4 rounded-xl shadow-sm flex items-center gap-4 bg-white relative cursor-pointer hover:bg-gray-50 transition border border-gray-100"
      onClick={onClick}
    >
      <div className="w-20 h-20 bg-yellow-50 rounded-xl flex justify-center items-center">
        {image && (
          <img
            loading="lazy"
            src={image}
            className="w-12 h-12"
            alt=""
          />
        )}
      </div>

      <div className="flex flex-col flex-1">
        <h3 className="font-semibold text-gray-800 text-base">{title}</h3>
        {description && (
          <p className="text-sm text-gray-500">{description}</p>
        )}
        <div className="flex items-center gap-1 mt-1">
          <img src={Images.ClockCircleIcon} alt="ClockCircleIcon" className="w-4 h-4" />
          <span className="text-xs text-gray-500">{time}</span>
        </div>
      </div>
    </div>
  );
};

export default ProfileItem;